import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Layout from '../../../layouts'
import LargeHero from '../../../components/elements/largeHero'
import { Body, SizedText, Canon } from '../../../components/elements/typography'
import Grid from '../../../components/elements/grid'
import ExternalLink from '../../../components/elements/externalLink'
import { useStaticQuery, graphql } from "gatsby"
import PoliciesMenu from "../../../components/molocules/menus/policiesMenu"
import SEO from '../../../components/elements/seo'

const TopBox = ({title, width, children}) => (
  <div css={{
    backgroundColor: `#fff`,
    //textAlign: `justify`,
    hyphens: `auto`,
    padding: `2rem 1.5rem 2rem 2rem`,
    '& p': {
      fontWeight: `600`,
      '& span': {
        fontWeight: `400`
      }
    }, 
  }}>
    <SizedText as="h2" smallSize="2.281" largeSize="1.802" css={{paddingBottom: `1rem`}}>{title}</SizedText>
    {children}
  </div>
)

const SafeActPage = ({}) => {

  const data = useStaticQuery(graphql`
    query SafeActQuery {
      policiesSafeactYaml {
        bankID
        loanOfficers {
          id
          name
          position
        }
      }
    }
  `)

  const loanOfficersData = data.policiesSafeactYaml.loanOfficers.map(i => (
    <div key={i.id} className="idTable" >
      <div className="tCell">{i.name}</div>
      <div className="tCell">{i.position}</div>
      <div className="tCell">NMLS ID: {i.id}</div>
    </div>
  ))


  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="S.A.F.E. Act | TCB Trust Center"
        description="The Secure and Fair Enforcement for Mortgage Licensing Act (SAFE Act) is a federal law designed to enhance consumer protection and reduce fraud in the mortgage lending industry."
        location="/about/policies/safe-act"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />  

      <LargeHero.Container
        padding="3rem 0 4rem 0"
        background={{
          //backgroundColor: `#b2a08a`,
          backgroundImage: `url(/images/background-deltas.jpg)`, 
          backgroundRepeat: `no-repeat`, 
          backgroundAttachment: `scroll`, 
          backgroundPosition: `top left`, 
          backgroundSize: `cover`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/about/", text: "About Us" },
          { path: "/about/policies/", text: "Policies" },
          { path: "/about/policies/safe-act", text: "S.A.F.E. Act" }
        ]}
        styles={{
          paddingBottom: `5rem`,
          overflow: `hidden`,
          '.breadcrumbs, .breadcrumbs [aria-current="page"]': {color: `#fff`},
          '.heroContent': { paddingBottom: `3rem`},
          '@media (min-width: 680px)': {
            '.heroContent': { width: `calc(72% - 1rem)`, marginBottom: `0`},
            '.heroImage': { width: `calc(40% - 1rem) !important`,},
          }
        }}
      >
        <LargeHero.Content styles={{paddingTop: `1rem`, color: `#fff`}}>
          <LargeHero.Eyebrow text="Policies & Disclosures" styles={{borderColor: `#fff !important`}}/>
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`,  'span': {display: `block`, lineHeight: `1`, padding: `0.5rem 0`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">S.A.F.E. Act Policy</SizedText>
          </h1>
        </LargeHero.Content>
        <LargeHero.Image >
          <StaticImage 
              css={{
                '@media (min-width: 680px)': { display: 'none !important' }, 
                '@media (min-width: 1300px)': { display: 'block !important' } 
              }} 
              src="../../../images/policies.png" 
              alt=""
            />
            <StaticImage 
              css={{
                display: `none !important`,  
                '@media (min-width: 680px)': { display: 'block !important' }, 
                '@media (min-width: 1300px)': { display: 'none !important' } 
              }} 
              src="../../../images/policies_cropped.png" 
              alt=""
            />
        </LargeHero.Image>
      </LargeHero.Container>

      <Grid.FullWidthSection>
        <Grid.Block start={[2,2,2,2,2,2,3]} span={[12,12,12,12,8,8,7]} css={{
          paddingBottom: `4rem`,
          'p': {textAlign: `justify`, color: "#707070"},
          'h1': {color: `#1d449e`},
          'h2': { marginTop: `2rem`, color: `#3498db`, fontFamily: `proxima-nova`}
        }}>

          <SizedText as="p" smallSize="1" largeSize="1.125" css={{padding: `4rem 0`, lineHeight: '1.5 !important'}}>
            The Secure and Fair Enforcement for Mortgage Licensing Act (SAFE Act) is a federal law designed to enhance consumer protection and reduce fraud in the 
            mortgage lending industry. The S.A.F.E. Act established a national registry for mortgage loan originators called the Nationwide Mortgage Licensing System 
            and Registry (NMLS). This list is maintained by the federal government and assigns a unique identification number to each registered professional.  This 
            identification number is provided to customers upon request and on certain loan documentation.  Each financial institution is also assigned a unique 
            identification number.  
            <br /><br />
            You can view registration information through <ExternalLink to="http://www.nmlsconsumeraccess.org/">NMLS Consumer Access Portal</ExternalLink>.  To perform a search for an individual Mortgage Loan Originator (MLO), click on 
            the link above and then type the MLO's NMLS ID in the search field. If you do not know the NMLS ID you can also search by name, city, state, and/or zip code.
            <br /><br />
            If you have general questions about NMLS Consumer Access, please contact the NMLS Call Center at 240-386-4444.
          </SizedText>

          <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
            NMLS Registered Loan Originators 
          </SizedText>
          <Body>
            It is the policy of The Claxton Bank to require all of its employees who engage in the origination of consumer purpose mortgage loans, including home equity loans and lines of credit, to maintain in good standing an active 
            registration on the NMLS. Below is the Bank’s listing of NMLS Registered Loan Originators with NMLS ID numbers which you may use to obtain loan originator information through the NMLS Consumer Access website.
          </Body>

          <div css={{
            '.idTable': {
              display:  `grid`,
              gridTemplateColumns: `1fr`, 
              borderBottom: `1px solid  rgb(90, 102, 115)`,
              '@media (min-width: 950px)': { gridTemplateColumns: `1.5fr 2fr 1.5fr`, borderBottom: `none`,},
              'div': { 
                padding: `1rem`,
                borderBottom: `none `,
              },
              '.tHead': { 
                backgroundColor: `slategray !important`,
                border: `1px solid  rgb(90, 102, 115)`,
                'h2': {
                  margin: `0`,
                  padding: `0`,
                  color: `#fff`,
                }
              },
              '.tCell': { 
                backgroundColor: `#fff`,
                border: `1px solid #ecf0f1`,
              },
            }
          }}>
          
            <div className="idTable" css={{
              margin: `3rem 0`,
      
            }}>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">The Claxton Bank</SizedText></div>
              <div className="tCell" css={{border: `1px solid  rgb(90, 102, 115) !important`}}>NMLS ID: {data.policiesSafeactYaml.bankID}</div>
            </div>

            <div css={{border: `1px solid  rgb(90, 102, 115)`,}}>
            <div className="idTable">
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">Name</SizedText></div>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">Position</SizedText></div>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">NMLS ID</SizedText></div>
            </div>
            {loanOfficersData}
            </div>

          </div>
        </Grid.Block>
        <Grid.Block start={[2,2,2,2,10,10]} span={[12,12,12,12,4,3]}
          css={{ 
            margin: `4rem 0`,
        }}>
          
          <PoliciesMenu />
        </Grid.Block>
      </Grid.FullWidthSection>
    </Layout> 
  )
}

export default SafeActPage
